import { Pipe, PipeTransform } from '@angular/core';
import { SettingService } from 'src/common/services/setting/setting.service';

@Pipe({
  name: 'realtorTooltip'
})
export class RealtorTooltipPipe implements PipeTransform {

  constructor(
    private setting?: SettingService,
  ) {
  }

  transform(realtorId: string, agencyId?: string): string {
    if (!realtorId) {
      return '';
    }

    const realtorName = this.setting?.getUserName(realtorId) || '';
    const resolvedAgencyId = agencyId || this.setting?.getAgency(realtorId);
    const agencyName = resolvedAgencyId
      ? (this.setting?.getParamValueName('agencies', resolvedAgencyId) || '')
      : '';

    if (agencyName) {
      return `${realtorName}&#13;${agencyName}`;
    }

    return realtorName;
  }
}
